export default __webpack_public_path__ + "static/media/xd.684770b1.svg";